module.exports = __webpack_public_path__ + "static/media/quote.95f8f679.svg";